import React, { ComponentType } from 'react';
import { Route, Switch, BrowserRouter } from 'react-router-dom';
import { routes } from './constants';
import RepresentationSelector from './../../Molecules/RepresentationSelector';

interface RouterProps {
  Header: ComponentType;
  ContentSection: ComponentType;
  Footer: ComponentType;
}

const Routes: React.FC<RouterProps> = ({ Header, ContentSection, Footer }) => {
  return (
    <BrowserRouter>
      <Header />
      <ContentSection>
        <Switch>
          <Route path={routes.home} component={RepresentationSelector} />
        </Switch>
      </ContentSection>
      <Footer/>
    </BrowserRouter>
  );
};

export default Routes;
